import styled from 'styled-components';

interface TypographyProps {
  level: 'displayMd';
}

const Typography = styled.div<TypographyProps>`
  ${({ theme, level }): string => {
    switch (level) {
      case 'displayMd':
        return `
          font-size: ${theme.configs.fonts.fontSize.lastEvent}px;
          line-height: 1.5;
          font-weight: 700;
        `;
      default:
        return '';
    }
  }}
`;

export default Typography;
